import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {lazy} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {clearDomForApp} from '@/helper';
import queryClient from '@/services/QueryService';
import SentryService from '@/services/SentryService';
import AppAuth from './AppAuth';

const {initSentryService, SentryErrorBoundary, sentryRootOptions} = SentryService;
const FallbackLoginScreen = lazy(() => import('@/screens/Fallback/fallbackLogin'));

const root = clearDomForApp();
initSentryService();

createRoot(root, sentryRootOptions).render(
    <BrowserRouter>
        <SentryErrorBoundary
            fallback={({error, resetError}) => <FallbackLoginScreen error={error} resetError={resetError} />}
        >
            <QueryClientProvider client={queryClient}>
                <AppAuth />
                <ReactQueryDevtools />
            </QueryClientProvider>
        </SentryErrorBoundary>
    </BrowserRouter>
);
